/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { RichTextToc } from "@simplicitycms/simplicity-richtext";
import { useSimpliCity } from "../../hooks/use-simplicity";

/**
 * Render richtext content to HTML
 * @param {object} props
 * @param {any} props.component
 */
export function RichTextComponent (props) {
    const component = props?.component;
    const { model } = useSimpliCity();
    const features = model?.features;
    const toc = features?.toc;

    return (
        <RichTextToc
            richtext={component?.richtext}
            enableToc={toc}
            className={"rich-text-component"}
        />
    );
}
